<template lang="pug">
.form-group
      label
        | {{ label }}
        
      vSelect(
        router-link,
        :value="value",
        :options="regions",
        :reduce="(option) => option.id",
        label="name",
        :multiple="multiple",
        :class="cssClass",
        @input="selection",
        :filter="filter"
      )
    
</template>
    
    <script>
    import vSelect from "vue-select";
    export default {
      name: "RegionSelect",
      components: { vSelect },
      props: {
        label: {
          type: String,
          default: "Regions",
        },
        value: {
          type: [String, Array],
          default: null,
        },
        cssClass: {
          type: String,
          default: "form-select-control",
        },
        multiple: Boolean,
        regionsList: {
          type: Array,
          default: function () {
            return [];
          },
        },
      },
      computed: {
        regions() {
          return this.regionsList && this.regionsList.length
            ? this.regionsList
            : this.$t("regions");
        },
      },
      methods: {
        selection(val) {
          this.$emit("input", val);
          this.$emit("region", val);
        },
        filter(options, search) {
          let search_results = options
            .filter((country) => {
              let searchHasAccents = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "") !== search;
              if (searchHasAccents) {
                   // Filter results by doing case insensitive match on name here
                  return country.name.toLowerCase().includes(search.toLowerCase());
               } else {
                  // Filter results by doing accent-sensitive match on name
                  return country.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(search.toLowerCase());
                }
            })
            .sort((a, b) => {
              // Sort results by matching name with keyword position in name
              if (
                a.name.toLowerCase().indexOf(search.toLowerCase()) >
                b.name.toLowerCase().indexOf(search.toLowerCase())
              ) {
                return 1;
              } else if (
                a.name.toLowerCase().indexOf(search.toLowerCase()) <
                b.name.toLowerCase().indexOf(search.toLowerCase())
              ) {
                return -1;
              } else {
                if (a.name > b.name) return 1;
                else return -1;
              }
            });
          return search_results.slice(0, 5);
        },
      },
    };
    </script>
    